import { render, staticRenderFns } from "./ServiceOnline.vue?vue&type=template&id=55f8482e&scoped=true"
import script from "./ServiceOnline.vue?vue&type=script&lang=js"
export * from "./ServiceOnline.vue?vue&type=script&lang=js"
import style0 from "./ServiceOnline.vue?vue&type=style&index=0&id=55f8482e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8482e",
  null
  
)

export default component.exports